import Grid from '@mui/material/Grid';
import PageTitle from 'src/components/PageTitle';
import AdminPanel from './AdminPanel';

function AdminDashboard() {
  return (
    <>
      <PageTitle />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <AdminPanel />
        </Grid>
      </Grid>
    </>
  );
}

export default AdminDashboard;
